module.exports = __webpack_public_path__ + "img/meinhilfsmittel.61e5bd23.svg";